import { jsxs, jsx } from 'react/jsx-runtime';

const root = "_root_mz469_1";
const closeButton = "_close-button_mz469_24";
const styles = {
	root: root,
	closeButton: closeButton
};

const ModalMediaContent = (props) => {
  return jsxs("div", { className: styles.root, "data-zds": true, children: [props.children, props.closeButton && jsx("div", { className: styles.closeButton, "data-zds": true, children: props.closeButton })] });
};

export { ModalMediaContent };
//# sourceMappingURL=ModalMediaContent.es.js.map
